import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDefinitionAudioCachedV1Response } from './get-definition-audio-cached-v1-response';
import { getDefinitionAudioCachedV1ResponseSchema } from './get-definition-audio-cached-v1-response';

export async function getDefinitionAudioCachedV1Api(
  slug: string,
): Promise<IValidatedResponse<IGetDefinitionAudioCachedV1Response>> {
  return getRequest<IGetDefinitionAudioCachedV1Response>({
    path: `/challenges/${slug}/audio/definition/cached/v1`,
    schema: getDefinitionAudioCachedV1ResponseSchema,
  });
}
